import { useState } from 'react'
import { useTranslation } from 'react-i18next'

// local imports
import icon from 'assets/icons/location.svg'
import { INotRatedReservations } from 'types/RateType'
import { IFloor } from 'types/FavoritesType'
import DateUtil from 'utils/DateUtil'
import RatingDialog from './RatingDialog'
import { ListItem, SidebarButton } from './styled'

interface IListViewProps {
  listItem: INotRatedReservations
  getReservationList: (showLoading?: boolean) => void
}

function ListView({ listItem, getReservationList }: IListViewProps) {
  const { t } = useTranslation()

  /* Dialog state & methods */
  const [dialog, setDialog] = useState(false)
  const openDialog = () => setDialog(true)
  const closeDialog = () => setDialog(false)

  const getAddress = (floor: IFloor) => {
    const { districtName, cityName, countryName, name } = floor || {}
    return `${name}, ${districtName}, ${cityName}, ${countryName}`
  }

  return (
    <>
      <ListItem key={`item_${listItem.reservationId}`}>
        <div className="mr-4">
          <img src={icon} className="location-img" alt="reservation-location" />
        </div>
        <div className="list-content">
          <div className="title">{listItem.floor.locationName}</div>
          <div className="subtitle">{listItem.floor.locationFirmName}</div>
          <div className="desc">{getAddress(listItem.floor)}</div>
        </div>

        <div className="list-content">
          <span className="res-date">{DateUtil.dateFormat(new Date(listItem.reservationDate))}</span>
        </div>

        <div className="px-3">
          <SidebarButton onClick={openDialog}>{t('evaluation.point')}</SidebarButton>
        </div>
      </ListItem>

      {/* Rating Dialog */}
      {dialog && (
        <RatingDialog
          closeDialog={closeDialog}
          visible={dialog}
          selectedRes={listItem}
          getReservationList={getReservationList}
        />
      )}
    </>
  )
}

export default ListView
